import React from 'react';
import { useEffect } from 'react';

export default function ScheduleTimeRedirect() {
  useEffect(() => {
    let leadData = window.localStorage.getItem('finauta_lead');
    if (leadData !== null) {
      const [firstName, lastName, email] = leadData.split('|');
      window.location.replace(
        `https://meetings.hubspot.com/oscar48/llamada-15-min?&firstName=${firstName}&lastName=${lastName}&email=${email}`,
      );
    } else {
      window.location.replace('https://meetings.hubspot.com/oscar48/llamada-15-min');
    }
  }, []);
  return <div></div>;
}
